export default {
  allFinancialRecurrences: [],
}
